import React, { useState } from 'react';
import useBillingStore from '../../../services/useBillingStore';

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount);
};

const ChangePlanDialog = ({ currentPlan, newPlan, onClose, onSuccess }) => {
  const { changePlan } = useBillingStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const priceDifference = (newPlan.price || 0) - (currentPlan.price || 0);
  const isUpgrade = priceDifference > 0;
  const isDowngrade = priceDifference < 0;

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);

    try {
      await changePlan(newPlan.id);
      onSuccess();
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Falha ao alterar plano. Tente novamente.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Confirmar Alteração de Plano</h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          {error && (
            <div className="co-error" style={{ marginBottom: '1rem' }}>
              {error}
            </div>
          )}

          <div className="plan-comparison">
            <div className="comparison-row">
              <div className="comparison-item">
                <div className="comparison-label">Plano Atual</div>
                <div className="comparison-value">{currentPlan.name}</div>
                <div className="comparison-price">{formatCurrency(currentPlan.price)}</div>
              </div>
              <div className="comparison-arrow">→</div>
              <div className="comparison-item">
                <div className="comparison-label">Novo Plano</div>
                <div className="comparison-value">{newPlan.name}</div>
                <div className="comparison-price">{formatCurrency(newPlan.price)}</div>
              </div>
            </div>

            {priceDifference !== 0 && (
              <div className="price-difference">
                <strong>Diferença:</strong>{' '}
                <span className={isUpgrade ? 'text-success' : 'text-warning'}>
                  {isUpgrade ? '+' : ''}{formatCurrency(priceDifference)}
                </span>
              </div>
            )}
          </div>

          {isDowngrade && (
            <div className="alert-warning" style={{ marginTop: '1rem' }}>
              <strong>Atenção ao fazer downgrade:</strong>
              <ul style={{ marginTop: '0.5rem', marginBottom: 0, paddingLeft: '1.5rem' }}>
                <li>Você pode perder acesso a recursos premium</li>
                <li>Limites de uso serão reduzidos</li>
                <li>Dados podem precisar ser ajustados aos novos limites</li>
              </ul>
            </div>
          )}

          {isUpgrade && (
            <div style={{ padding: '1rem', backgroundColor: '#f8f9fa', borderRadius: '4px', marginTop: '1rem' }}>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#495057' }}>
                A cobrança será proporcional ao tempo restante do ciclo atual.
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Processando...' : 'Confirmar Alteração'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePlanDialog;
